import API from './API.ts'

export default {
  //
  // GET
  //
  getCustomerCredit ({ bookingId, bookingGroupId, customerId, includeTimeline }) {
    return API.httpClient.get('customer-credit/customer', {
      params: {
        booking_id: bookingId ?? null,
        booking_group_id: bookingGroupId ?? null,
        customer_id: customerId ?? null,
        include_timeline: includeTimeline
      }
    })
  },

  //
  // POST
  //
  customerCreditPayment ({ customerId, paymentMethodId, amount }) {
    return API.httpClient.post('customer-credit/payment', {
      customer_id: customerId,
      payment_method_id: paymentMethodId,
      amount
    })
  },
  registerCustomerCreditPayment ({ customerId, paymentMethodId, accountId, amount, date }) {
    return API.httpClient.post('customer-credit/register-payment', {
      customer_id: customerId,
      payment_method_id: paymentMethodId,
      account_id: accountId,
      date,
      amount
    })
  },
  cancelCustomerCreditPayment () {
    return API.httpClient.post('customer-credit/cancel-credit-payment', {})
  }
}
